import React from 'react';
import SideBarElements from './sideBarOption';
import { sidebarDetails } from '../../utils/const';
import { connect } from 'react-redux';
import { htmlDecode } from '../../utils/commonFunctions';
import { withRouter } from 'react-router';
import { setActiveKey } from '../../redux/myCourse/myCourse.actions';
import { compose } from 'redux';
import MenuAnimation from '../utils/animations/menu';

const SidebarContents = ({
	units,
	course_id,
	setActiveKey,
	match,
	location,
	activeUnit,
	isParent,
	isRetail
}) => {
	const isMyCoursePage = location.pathname === '/mycourse';
	return (
		<MenuAnimation open={true} className="step-main-nav" id="main-menu">
			{Object.keys(units).length > 0 && isMyCoursePage ? (
				<>
					<SideBarElements redirectLink={'/mycourse'} PageName="My Course" />
					{Object.keys(units).map((unit) => {
						const { unit_name } = units[unit];
						return (
							<li
								key={`key_${course_id}_${unit}`}
								className={`menu-unit ${
									parseInt(unit, 10) === activeUnit ? 'active-menu-unit' : ''
								}`}
								onClick={() => {
									setActiveKey(parseInt(unit, 10));
									document.getElementById(`unit_${course_id}_${unit}`).scrollIntoView({
										behavior: 'smooth',
										block: 'center',
										inline: 'nearest',
									});
								}}
							>
								{htmlDecode(unit_name)}
							</li>
						);
					})}
				</>
			) : null}
			{Object.keys(sidebarDetails)
				.filter(
					(x) =>
						(window.outerWidth < 768 ? x : sidebarDetails[x]?.isMobile !== 1) && //show profile & history in mob view
						(!!isParent ? x : sidebarDetails[x]?.isParent !== 1) && (sidebarDetails[x]?.PageName !== 'Buy a Course' || isRetail), //show kids course if isParent equals 1
				)
				.map((detail, index) => (
					<SideBarElements key={index} {...sidebarDetails[detail]} />
				))}
		</MenuAnimation>
	);
};

const mapStateToProps = (state) => {
	const {
		units,
		requestedUnit,
		currentUnitOrder,
		coursedetails: { course_id },
		activeUnit,
	} = state.rootReducer.myCourse;
	const { isParent: parent } = state.rootReducer.profileDetails;
	const { user_profile: { isParent } = {} } = state.rootReducer.userDetails;
	const { isRetail } = state.rootReducer.loginDetails;

	return {
		units,
		requestedUnit,
		currentUnitOrder,
		course_id,
		activeUnit,
		location: state.router,
		isRetail,
		isParent: isParent || parent,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		setActiveKey: (val) => dispatch(setActiveKey(val)),
	};
};

export default compose(
	withRouter,
	connect(mapStateToProps, mapDispatchToProps),
)(SidebarContents);
